<template>
    <div class="wineguide-container">
        <div class="itips-head">
            <div class="container">
                <div class="inner-page-title">{{ $t("home-top4") }}</div>
                <div class="inenr-page-breadcrumb">
                    <div class="inner-page-bread-line"></div>
                </div>
            </div>
        </div>
        <div class="container">
            <div class="wine-guide-body">
                <div class="wine-guide-left hide-mobile">
                    <div class="wine-guide-left-title">
                        <nuxt-link class="wine-guide-back" :to="localePath('/wine-guide/italy/tuscany')"></nuxt-link>
                        Producers
                    </div>
                    <nuxt-link class="wine-guide-country"
                               :to="localePath('/wine-guide/italy/tuscany/avignonesi')">Avignonesi
                    </nuxt-link>
                    <nuxt-link class="wine-guide-country two-line"
                               :to="localePath('/wine-guide/italy/tuscany/azienda-agricola-casanova-di-neri')">Azienda
                        Agricola Casanova di Neri
                    </nuxt-link>
                    <nuxt-link class="wine-guide-country"
                               :to="localePath('/wine-guide/italy/tuscany/azienda-salvioni')">Azienda Salvioni
                    </nuxt-link>
                    <nuxt-link class="wine-guide-country"
                               :to="localePath('/wine-guide/italy/tuscany/castiglione-del-bosco')">Castiglione del Bosco
                    </nuxt-link>
                    <nuxt-link class="wine-guide-country"
                               :to="localePath('/wine-guide/italy/tuscany/conti-constani')">Conti Constani
                    </nuxt-link>
                    <nuxt-link class="wine-guide-country"
                               :to="localePath('/wine-guide/italy/tuscany/fattoria-le-pupille')">Fattoria Le Pupille
                    </nuxt-link>
                    <nuxt-link class="wine-guide-country"
                               :to="localePath('/wine-guide/italy/tuscany/fattoria-poggio-di-sotto')">Fattoria Poggio di
                        Sotto
                    </nuxt-link>
                    <nuxt-link class="wine-guide-country"
                               :to="localePath('/wine-guide/italy/tuscany/fontodi')">Fontodi
                    </nuxt-link>
                    <nuxt-link class="wine-guide-country"
                               :to="localePath('/wine-guide/italy/tuscany/frescobaldi')">Frescobaldi
                    </nuxt-link>
                    <nuxt-link class="wine-guide-country"
                               :to="localePath('/wine-guide/italy/tuscany/gianfranco-soldera')">Gianfranco Soldera
                    </nuxt-link>
                    <nuxt-link class="wine-guide-country"
                               :to="localePath('/wine-guide/italy/tuscany/isole-e-olena')">Isole e Olena
                    </nuxt-link>
                    <nuxt-link class="wine-guide-country"
                               :to="localePath('/wine-guide/italy/tuscany/marchesi-antinori')">Marchesi Antinori
                    </nuxt-link>
                    <nuxt-link class="wine-guide-country"
                               :to="localePath('/wine-guide/italy/tuscany/podere-poggio-scalette')">Podere Poggio
                        Scalette
                    </nuxt-link>
                    <nuxt-link class="wine-guide-country"
                               :to="localePath('/wine-guide/italy/tuscany/poderi-boscarelli')">Poderi Boscarelli
                    </nuxt-link>
                    <nuxt-link class="wine-guide-country active"
                               :to="localePath('/wine-guide/italy/tuscany/rocca-di-frassinello')">Rocca di Frassinello
                    </nuxt-link>
                    <nuxt-link class="wine-guide-country"
                               :to="localePath('/wine-guide/italy/tuscany/tenuta-dell-ornellaia')">Tenuta dell’Ornellaia
                    </nuxt-link>
                    <nuxt-link class="wine-guide-country"
                               :to="localePath('/wine-guide/italy/tuscany/tenuta-di-trinoro')">Tenuta di Trinoro
                    </nuxt-link>
                    <nuxt-link class="wine-guide-country"
                               :to="localePath('/wine-guide/italy/tuscany/tenuta-san-guido')">Tenuta San Guido
                    </nuxt-link>
                </div>
                <div class="show-mobile">
                    <div class="wine-guide-left-title">
                        <nuxt-link class="wine-guide-back" :to="localePath('/wine-guide/italy/tuscany')"></nuxt-link>
                        Producers
                    </div>
                    <v-select
                        :items="items"
                        v-model="select"
                        label="Please choose"
                        single-line
                        item-text="report"
                        item-value="src"
                        return-object
                        class="show-mobile show-mobile-select"
                        v-on:change="changeRoute"
                    ></v-select>
                </div>
                <div v-if="$i18n.locale === 'it'" class="wine-guide-right">
                    <div class="howto-title">Rocca di Frassinello</div>
                    <div class="howto-separator"></div>
                    <div class="howto-text">
                        SuperTuscan non ha mai portato meglio il suo nome. Il figlio dell'amore di due cantine iconiche, Rocca di
                        Frassinello è uno stallone italiano con un po' di ooh la la. La cantina potrebbe essere giovane -
                        la prima annata è stata prodotta solo nel 2004, ma ha anni di eredità vinicola su cui ripiegare
                        SU. Vale a dire i potenti nomi di Castellare di Castellina e la prima crescita Domaine du Barons de
                        Rothschild-Lafite. Non male per un nuovo arrivato, eh?
                    </div>

                    <div class="howto-title2">Due diventa uno</div>
                    <div class="howto-text">
                        La joint venture tra queste due grandi potenze enologiche sembrava inizialmente improbabile.
                        Paolo Panerai, proprietario di Castellare di Castellina in Chianti, era infatti a conoscenza di Eric de
                        Rothschild come Rothschild aveva quotato sui milanesi la casa editrice di Panerai, Class Editori
                        Borsa valori. Nonostante il rispetto reciproco, nessuna JV era in cantiere. Quello
                        sarebbe presto cambiato; una cosa tira l'altra e Panerai ha invitato Rothschild nella regione costiera
                        della Maremma Toscana dove aveva appena acquistato dei terreni. Rothschild era in soggezione. "Se potete
                        compra l'intera valle", ha detto, "faremo di questa una joint venture". I dadi erano lanciati e
                        più in fretta di quanto si possa dire mamma mia, avevano comprato 500 ettari sulle dolci colline
                        tra Bolgheri e Scansano. Era il 1999.
                    </div>

                    <div class="howto-title2">Francia contro Italia</div>
                    <div class="howto-text">
                        Il terroir più importante di Rocca di Frassinello è la sua arma non così segreta. Con caratteristiche
                        che sono molto simili a quelli che si trovano nel Chianti e a Montalcino (pur essendo con temperature più elevate),
                        Panerai e Rothschild hanno piantato 83 ettari al 50% di Sangioveto e un mix al 50% di Cabernet
                        Sauvignon, Merlot, Syrah e Vermentino. I vitigni di Merlot e Cabernet piantati a Rocca lo sono
                        cloni di quelli di Lafite. La terra è coltivata pensando alla biodiversità, mentre il mare costante
                        la brezza che arriva dal Mar Tirreno impedisce alle viti di seccarsi sotto il caldo toscano
                        sole. Si potrebbe dire che questo melange è un perfetto mix di patrimonio enologico francese e
                        Poesia italiana ricca e saporita. Insieme, il risultato è il migliore di entrambi i paesi.
                    </div>

                    <div class="howto-title2">La squadra dei sogni</div>
                    <div class="howto-text">
                        Poi è arrivata la squadra. Con così tanto in gioco, era fondamentale farlo bene. Panerai lo era
                        nominato presidente e Christophe Salin, CEO di Domain-Lafite, vicepresidente. La cura del
                        vigneti e la cantina fu affidata congiuntamente ad Alessandro Cellai, enologo e generale
                        manager di Castellare di Castellina, e Christian Le Sommer, allora manager delle società di
                        Dominio con esclusione di Lafite. Per consolidare la loro JV, il famoso architetto Renzo Piano (di
                        il Centro Georges Pompidou di Parigi e The Shard a Londra) è stato incaricato di progettare il
                        cantina - un primo progetto per lui. Sebbene la partnership non sia più attiva,
                        Rothschild e Panerai rimangono buoni amici, la cui testimonianza si trova nel bicchiere di
                        il loro meraviglioso vino.
                    </div>

                    <div class="howto-title2">Fatti e annate notevoli</div>
                    <div class="howto-text">
                        <ul>
                            <li>La tenuta ha investito molto nell'enoturismo. Per un'esperienza completamente autentica,
                                gli ospiti possono soggiornare nella guest house progettata, passeggiare tra gli splendidi vigneti e ammirare il
                                numerosi resti etruschi. Un antico cimitero e un piccolo museo - completo di an
                                Esperienza di degustazione di vini etruschi - disponibile in loco.
                            </li>
                            <li>Rocca di Frassinello ha sei etichette. Gli investitori dovrebbero prestare attenzione al suo vino Bafferono: più alto sia in termini di prezzo che di qualità, è qui che si trovano le migliori opportunità di investimento.
                            </li>
                            <li>Il bellissimo vino Baffonero è forse il fiore all'occhiello di Rocca. L'offerta del 2015 era
                                dato un alto punteggio di 94/100 da Robert Parker, mentre l'annata 2016 ha ottenuto 93/100
                                di Antonio Galloni.
                            </li>
                        </ul>
                    </div>
                </div>
                <div v-else-if="$i18n.locale === 'de'" class="wine-guide-right">
                    <div class="howto-title">Rocca di Frassinello</div>
                    <div class="howto-separator"></div>
                    <div class="howto-text">
                        SuperTuscan hat seinen Namen noch nie besser getragen. Das Liebeskind zweier ikonischer Weingüter: Rocca di
                        Frassinello ist ein italienischer Hengst mit einem Hauch von Ooh la la. Das Weingut könnte jung sein -
                        Der erste Jahrgang wurde erst im Jahr 2004 produziert – er kann jedoch auf eine jahrelange Weinbautradition zurückblicken
                        An. Nämlich die mächtigen Namen Castellare di Castellina und erstes Wachstum Domaine du Barons de
                        Rothschild-Lafite. Nicht schlecht für einen Neuling in der Gegend, oder?
                    </div>

                    <div class="howto-title2">Aus zwei wird eins</div>
                    <div class="howto-text">
                        Das Joint Venture dieser beiden großen önologischen Kraftpakete schien zunächst unwahrscheinlich.
                        Paolo Panerai, Besitzer von Castellare di Castellina in Chianti, kannte tatsächlich Eric de
                        Rothschild hatte als Rothschild Panerais Verlag Class Editori an der Mailänder Börse gelistet
                        Börse. Trotz des gegenseitigen Respekts füreinander waren keine Joint Ventures geplant. Das
                        würde sich bald ändern; Eins führte zum anderen und Panerai lud Rothschild in die Küstenregion ein
                        der toskanischen Maremma, wo er gerade Land gekauft hatte. Rothschild war voller Ehrfurcht. "Falls Sie können
                        „Das ganze Tal kaufen“, sagte er, „wir werden daraus ein Joint Venture machen.“ Die Würfel waren gefallen und
                        Schneller als man sagen kann, Mamma Mia, hatten sie 500 Hektar auf den sanften Hügeln gekauft
                        zwischen Bolgheri und Scansano. Es war 1999.
                    </div>

                    <div class="howto-title2">Frankreich gegen Italien</div>
                    <div class="howto-text">
                        Das überaus wichtige Terroir von Rocca di Frassinello ist seine nicht ganz so geheime Waffe. Mit Eigenschaften
                        die denen im Chianti und Montalcino sehr ähnlich sind (allerdings mit höheren Temperaturen),
                        Panerai und Rothschild bepflanzten 83 Hektar mit 50 % Sangioveto und 50 % Cabernet-Mischung
                        Sauvignon, Merlot, Syrah und Vermentino. Die in Rocca gepflanzten Merlot- und Cabernet-Reben sind
                        Klone von denen von Lafite. Das Land wird unter Berücksichtigung der Artenvielfalt bewirtschaftet, während das Meer konstant ist
                        Die vom Tyrrhenischen Meer wehende Brise verhindert, dass die Reben unter der heißen Toskana austrocknen
                        Sonne. Man könnte sagen, dass diese Melange eine perfekte Mischung aus französischem Weinbau-Erbe und ist
                        Italienische reiche und geschmackvolle Poesie. Zusammengenommen ist das Ergebnis das Beste aus beiden Ländern.
                    </div>

                    <div class="howto-title2">Das Dreamteam</div>
                    <div class="howto-text">
                        Als nächstes kam das Team. Da so viel auf dem Spiel stand, war es entscheidend, dies richtig zu machen. Panerai war
                        zum Vorsitzenden ernannt und Christophe Salin, CEO von Domain-Lafite, zum stellvertretenden Vorsitzenden. Die Betreuung der
                        Die Weinberge und der Weinkeller wurden gemeinsam dem Önologen und General Alessandro Cellai anvertraut
                        Geschäftsführer von Castellare di Castellina, und Christian Le Sommer, damals Geschäftsführer der Unternehmen von
                        Domain mit Ausnahme von Lafite. Um ihr Joint Venture zu festigen, hat der berühmte Architekt Renzo Piano (von
                        Das Centre Georges Pompidou in Paris und The Shard in London wurden mit der Gestaltung beauftragt
                        Weingut - ein erstes Projekt für ihn. Obwohl die Partnerschaft nicht mehr besteht,
                        Rothschild und Panerai bleiben gute Freunde, was im Glas bezeugt wird
                        ihr herrlicher Wein.
                    </div>

                    <div class="howto-title2">Bemerkenswerte Fakten und Jahrgänge</div>
                    <div class="howto-text">
                        <ul>
                            <li>Das Weingut hat stark in den Weintourismus investiert. Für ein völlig authentisches Erlebnis,
                                Gäste können im gestalteten Gästehaus übernachten, durch die wunderschönen Weinberge schlendern und die Weingärten besichtigen
                                viele etruskische Überreste. Eine alte Grabstätte und ein kleines Museum – komplett mit einer
                                Verkostung etruskischer Weine – finden Sie vor Ort.
                            </li>
                            <li>Rocca di Frassinello hat sechs Etiketten. Anleger sollten jedoch auf den Bafferono-Wein achten – dieser ist sowohl im Preis als auch in der Qualität höher und bietet hier die besten Investitionsmöglichkeiten.
                            </li>
                            <li>Der wunderschöne Baffonero-Wein ist vielleicht das Juwel in Roccas Krone. Das Angebot von 2015 war
                                Robert Parker erhielt eine hohe Bewertung von 94/100, während der Jahrgang 2016 mit 93/100 bewertet wurde
                                von Antoni Galloni.
                            </li>
                        </ul>
                    </div>
                </div>
                <div v-else-if="$i18n.locale === 'fr'" class="wine-guide-right">
                    <div class="howto-title">Rocca di Frassinello</div>
                    <div class="howto-separator"></div>
                    <div class="howto-text">
                        SuperTuscan n'a jamais mieux porté son nom. L'enfant amoureux de deux caves emblématiques, Rocca di
                        Frassinello est un étalon italien avec un peu de ooh la la. La cave est peut-être jeune -
                        le premier millésime n'a été produit qu'en 2004 - mais il a des années d'héritage viticole pour se replier
                        sur. A savoir les grands noms de Castellare di Castellina et premier cru classé Domaine du Barons de
                        Rothschild-Lafite. Pas mal pour un petit nouveau dans le quartier, hein?
                    </div>

                    <div class="howto-title2">Deux deviennent un</div>
                    <div class="howto-text">
                        La joint-venture entre ces deux grandes puissances œnologiques semblait au premier abord improbable.
                        Paolo Panerai, propriétaire de Castellare di Castellina in Chianti connaissait en effet Eric de
                        Rothschild car Rothschild avait inscrit la maison d'édition de Panerai, Class Editori, sur le marché milanais.
                        Bourse. Malgré un respect mutuel, aucune JV n'était en préparation. Ce
                        changerait bientôt; de fil en aiguille, Panerai a invité Rothschild dans la région côtière
                        de la Maremme toscane où il venait d'acheter un terrain. Rothschild était impressionné. "Si vous le pouvez
                        acheter toute la vallée », a-t-il dit « nous allons en faire une coentreprise ». Les dés sont jetés et
                        plus vite que tu ne peux dire mamma mia, ils avaient acheté 500 hectares sur les douces collines
                        entre Bolgheri et Scansano. C'était en 1999.
                    </div>

                    <div class="howto-title2">France contre Italie</div>
                    <div class="howto-text">
                        Le terroir si important de Rocca di Frassinello est son arme pas si secrète. Avec des caractéristiques
                        qui ressemblent beaucoup à celles du Chianti et de Montalcino (bien qu'avec des températures plus élevées),
                        Panerai et Rothschild ont planté 83 hectares à 50 % de Sangioveto et un mélange à 50 % de Cabernet
                        Sauvignon, Merlot, Syrah et Vermentino. Les vignes de Merlot et de Cabernet plantées à Rocca sont
                        clones de ceux de Lafite. La terre est cultivée en tenant compte de la biodiversité, tandis que la mer constante
                        la brise venant de la mer Tyrrhénienne empêche les vignes de se dessécher sous la chaleur toscane
                        soleil. On pourrait dire que ce mélange est un mélange parfait de l'héritage viticole français et
                        Poésie italienne riche et savoureuse. Ensemble, le résultat est le meilleur des deux pays.
                    </div>

                    <div class="howto-title2">L'équipe de rêve</div>
                    <div class="howto-text">
                        Vient ensuite l'équipe. Avec tant d'enjeux, il était crucial de bien faire les choses. Panerai était
                        nommé président et Christophe Salin, directeur général de Domain-Lafite, vice-président. Le soin de la
                        les vignes et la cave ont été confiées conjointement à Alessandro Cellai, œnologue et général
                        gérant de Castellare di Castellina, et Christian Le Sommer, alors gérant des sociétés de
                        Domaine à l'exclusion de Lafite. Pour consolider leur JV, le célèbre architecte Renzo Piano (de
                        le Centre Georges Pompidou à Paris et The Shard à Londres) a été chargé de concevoir le
                        cave - un premier projet pour lui. Bien que le partenariat ne soit plus en place,
                        Rothschild et Panerai restent de bons amis, dont témoigne le verre de
                        leur magnifique vin.
                    </div>

                    <div class="howto-title2">Faits marquants et millésimes</div>
                    <div class="howto-text">
                        <ul>
                            <li>Le domaine a beaucoup investi dans l'oenotourisme. Pour une expérience totalement authentique,
                                les clients peuvent séjourner dans la maison d'hôtes conçue, se promener dans les magnifiques vignobles et admirer le
                                nombreux vestiges étrusques. Un ancien cimetière et un petit musée - avec un
                                Expérience de dégustation de vins étrusques - peut être trouvée sur place.
                            </li>
                            <li>Rocca di Frassinello compte six labels. Les investisseurs devraient cependant rechercher son vin Bafferono - plus élevé en prix et en qualité, c'est là que se trouvent les meilleures opportunités d'investissement.
                            </li>
                            <li>Le beau vin Baffonero est peut-être le joyau de la couronne de Rocca. L'offre de 2015 était
                                noté 94/100 par Robert Parker, tandis que le millésime 2016 a obtenu 93/100
                                d'Antoni Galloni.
                            </li>
                        </ul>
                    </div>
                </div>
                <div v-else class="wine-guide-right">
                    <div class="howto-title">Rocca di Frassinello</div>
                    <div class="howto-separator"></div>
                    <div class="howto-text">
                        SuperTuscan has never carried its name better. The lovechild of two iconic wineries, Rocca di
                        Frassinello is an Italian stallion with a little bit of ooh la la. The winery might be young -
                        the first vintage was only produced in 2004 - but it has years of winemaking legacy to fall back
                        on. Namely the mighty names of Castellare di Castellina and first growth Domaine du Barons de
                        Rothschild-Lafite. Not bad for a new kid on the block, eh?
                    </div>

                    <div class="howto-title2">Two becomes one</div>
                    <div class="howto-text">
                        The joint venture between these two great oenological powerhouses seemed improbable at first.
                        Paolo Panerai, owner of Castellare di Castellina in Chianti was indeed aware of Eric de
                        Rothschild as Rothschild had listed Panerai’s publishing house, Class Editori, on the Milanese
                        stock exchange. Despite a mutual respect for one another, no JVs were in the pipeline. That
                        would soon change; one thing led to another and Panerai invited Rothschild to the coastal region
                        of Tuscany’s Maremma where he had just purchased some land. Rothschild was in awe. "If you can
                        buy the whole valley”, he said “we will make this a joint venture". The dice were cast and
                        quicker than you can say mamma mia, they had bought 500 hectares on the gently rolling hills
                        between Bolgheri and Scansano. It was 1999.
                    </div>

                    <div class="howto-title2">France vs. Italy</div>
                    <div class="howto-text">
                        Rocca di Frassinello’s all important terroir is its not so secret weapon. With characteristics
                        that are very like those found in Chianti and Montalcino (albeing with higher temperatures),
                        Panerai and Rothschild planted 83-hectares to 50% Sangioveto, and a 50% mix of Cabernet
                        Sauvignon, Merlot, Syrah and Vermentino. The Merlot and Cabernet vines planted in Rocca are
                        clones of those of Lafite. Land is farmed with biodiversity in mind, while the constant sea
                        breeze coming in from the Tyrrhenian Sea keeps the vines from drying out under the hot Tuscan
                        sun. You could say that this melange is a perfect mix of both French winemaking heritage and
                        Italian rich and flavourful poetry. Together, the result is the best of both countries.
                    </div>

                    <div class="howto-title2">The dream team</div>
                    <div class="howto-text">
                        Next came the team. With so much at stake, it was crucial to get this right. Panerai was
                        appointed chairman and Christophe Salin, CEO of Domain-Lafite, vice chairman. The care of the
                        vineyards and the cellar was jointly entrusted to Alessandro Cellai, oenologist and general
                        manager of Castellare di Castellina, and Christian Le Sommer, then manager of the companies of
                        Domain with the exclusion of Lafite. To consolidate their JV, famed architect Renzo Piano (of
                        the Georges Pompidou Centre in Paris and The Shard in London fame) was tasked with designing the
                        winery - a first time project for him. Although the partnership is no longer in place,
                        Rothschild and Panerai remain good friends, testimony of which can be found in the glass of
                        their gorgeous wine.
                    </div>

                    <div class="howto-title2">Notable facts and vintages</div>
                    <div class="howto-text">
                        <ul>
                            <li>The estate has invested heavily in wine tourism. For a fully authentic experience,
                                guests can stay in the designed guest house, stroll the beautiful vineyards and view the
                                many Etruscan remains. An ancient burial ground and a small museum - complete with an
                                Etruscan wine tasting experience - can be found on site.
                            </li>
                            <li>Rocca di Frassinello has six labels. Investors should look out for its Bafferono wine though - higher in both price and quality, this is where the best investment opportunities lie.
                            </li>
                            <li>The beautiful Baffonero wine is perhaps the jewel in Rocca’s crown. 2015s offering was
                                given a lofty score of 94/100 by Robert Parker, while 2016s vintage was granted 93/100
                                by Antoni Galloni.
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "TenutaDellOrnellaia",
    head: {
        title: 'Rocca di Frassinello | Vindome Wine Guide',
        meta: [
            {
                hid: 'description',
                name: 'description',
                content: 'Discover the premium quality wines of Rocca di Frassinello, a renowned wine producer in Tuscany, Italy. Experience the rich blend of traditional techniques and modern winemaking methods that bring out the essence of the region in every sip.'
            }
        ],
        bodyAttrs: {
            class: 'wine-guide inner-page'
        }
    },
    data() {
        return {
            select: {report: 'Tenuta dell’Ornellaia', src: '/wine-guide/italy/tuscany/tenuta-dell-ornellaia'},
            items: [
                {report: 'Avignonesi', src: '/wine-guide/italy/tuscany/аvignonesi'},
                {
                    report: 'Azienda Agricola Casanova di Neri',
                    src: '/wine-guide/italy/tuscany/azienda-agricola-casanova-di-neri'
                },
                {report: 'Azienda Salvioni', src: '/wine-guide/italy/tuscany/azienda-salvioni'},
                {report: 'Castiglione del Bosco', src: '/wine-guide/italy/tuscany/castiglione-del-bosco'},
                {report: 'Conti Constani', src: '/wine-guide/italy/tuscany/conti-constani'},
                {report: 'Fattoria Le Pupille', src: '/wine-guide/italy/tuscany/fattoria-le-pupille'},
                {report: 'Fattoria Poggio di Sotto', src: '/wine-guide/italy/tuscany/fattoria-poggio-di-sotto'},
                {report: 'Fontodi', src: '/wine-guide/italy/tuscany/fontodi'},
                {report: 'Frescobaldi', src: '/wine-guide/italy/tuscany/frescobaldi'},
                {report: 'Gianfranco Soldera', src: '/wine-guide/italy/tuscany/gianfranco-soldera'},
                {report: 'Isole e Olena', src: '/wine-guide/italy/tuscany/isole-e-olena'},
                {report: 'Marchesi Antinori', src: '/wine-guide/italy/tuscany/marchesi-antinori'},
                {report: 'Podere Poggio Scalette', src: '/wine-guide/italy/tuscany/podere-poggio-scalette'},
                {report: 'Poderi Boscarelli', src: '/wine-guide/italy/tuscany/poderi-boscarelli'},
                {report: 'Tenuta dell’Ornellaia', src: '/wine-guide/italy/tuscany/tenuta-dell-ornellaia'},
                {report: 'Tenuta di Trinoro', src: '/wine-guide/italy/tuscany/tenuta-di-trinoro'},
                {report: 'Tenuta San Guido', src: '/wine-guide/italy/tuscany/tenuta-san-guido'}
            ]
        }
    },
    methods: {
        changeRoute(a) {
                this.$router.push({path: this.localePath(a.src) });
            }
    }
}
</script>

<style scoped>
.container {
    max-width: 1170px;
    padding: 0;
    font-family: 'Poppins', sans-serif;
}
.wine-guide-body {
    padding-top: 35px;
}

.wine-guide-left {
    width: 300px;
    display: inline-block;
}

.wine-guide-right {
    display: inline-block;
    width: calc(100% - 305px);
    vertical-align: top;
}

.wine-guide-left-title {
    font-weight: 600;
    color: #024E7B;
    font-size: 18px;
    height: 57px;
    line-height: 57px;
}

.wine-guide-country {
    display: block;
    height: 57px;
    line-height: 57px;
    text-decoration: none;
    color: #000;
    font-size: 16px;
    padding-left: 30px;
    width: 260px;
    border-left: 3px solid transparent;
}

.wine-guide-country:hover,
.wine-guide-country.active {
    border-color: #024E7B;
    background: #E5EDF2;
}
</style>
